module.exports = __webpack_public_path__ + "img/WechatIMG27.287c1151.png";